import React, { Fragment, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { DMM_API_HOST, DMM_API_KEY } from '../../_Components/Common/common'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import { Pagination, InputGroup, FormControl, Button } from 'react-bootstrap'
import Body from '../Common/Body'

const Ranking = props => {
  const [assistantList, setAssistantList] = useState([])
  const [pageMap, setPageMap] = useState({})
  const [rankingList, setRankingList] = useState([])
  const [autoRankingList, setAutoRankingList] = useState([])
  const [dmmRankingList, setDmmRankingList] = useState([])
  const [pageNumber, setPageNumber] = useState(1)
  const [search, setSearch] = useState('')
  const [fieldList, setFieldList] = useState([])
  const [drag, setDrag] = useState(false)
  const [isScroll, setIsScroll] = useState('')
  const [posX, setPosX] = useState(0)
  const [gender, setGender] = useState('all')

  const rankingRef = useRef()

  useEffect(() => {
    getAssistantList(1, search)
    getRankingList()
    getAutoRankingList()
    getDmmRankingList()
  }, [])

  useEffect(() => {
    getAutoRankingList()
    getDmmRankingList()
  }, [gender])

  useEffect(() => {
    getAssistantList(pageNumber, search)
  }, [pageNumber])

  const getAssistantList = async (pageNumber, search) => {
    await axios
      .get(
        `${DMM_API_HOST}/v4.0.1/assistant?search=${search}&pageNumber=${pageNumber}&limit=50&status=Y`,
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        if (fieldList.length === 0) {
          let fields = []

          fields.push('profileImg')
          fields.push('assistantImg')

          for (let key in data.body.assistantList[0]) {
            if (key !== 'profileImg' && key !== 'assistantImg') {
              fields.push(key)
            }
          }

          setFieldList(fields)
        }

        setAssistantList(data.body.assistantList)
        setPageMap(data.body.pageMap)
      })
  }

  const getRankingList = async () => {
    await axios
      .get(`${DMM_API_HOST}/v4.0.1/assistant/dmm/ranking`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(({ data }) => {
        setRankingList(data.body)
      })
  }

  const getAutoRankingList = async () => {
    await axios
      .get(
        `${DMM_API_HOST}/v4.0.1/assistant/dmm/ranking/auto?gender=${gender}`,
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        setAutoRankingList(data.body)
      })
  }

  const getDmmRankingList = async () => {
    await axios
      .get(`${DMM_API_HOST}/v4/dmm/events/characters/rankings`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(({ data }) => {
        if (data.body) {
          if (gender === 'male') {
            const maleList = data.body.alliance_ranking_man.map(d => {
              return {
                character_id: atob(d.chat_url.split('/').pop()),
                character_name: d.character_name,
                chat_url: d.chat_url,
                image_url: d.image_url,
                description: d.description,
                gender: 'male',
              }
            })
            setDmmRankingList(maleList)
          } else if (gender === 'female') {
            const femaleList = data.body.alliance_ranking_woman.map(d => {
              return {
                character_id: atob(d.chat_url.split('/').pop()),
                character_name: d.character_name,
                chat_url: d.chat_url,
                image_url: d.image_url,
                description: d.description,
                gender: 'female',
              }
            })
            setDmmRankingList(femaleList)
          } else if (gender === 'all') {
            const maleList = data.body.alliance_ranking_man.map(d => {
              return {
                character_id: atob(d.chat_url.split('/').pop()),
                character_name: d.character_name,
                chat_url: d.chat_url,
                image_url: d.image_url,
                description: d.description,
                gender: 'male',
              }
            })
            const femaleList = data.body.alliance_ranking_woman.map(d => {
              return {
                character_id: atob(d.chat_url.split('/').pop()),
                character_name: d.character_name,
                chat_url: d.chat_url,
                image_url: d.image_url,
                description: d.description,
                gender: 'female',
              }
            })
            const allList = maleList.concat(femaleList)
            setDmmRankingList(allList)
          }
        }
      })
  }

  const insertRanking = async assistantId => {
    await axios
      .post(
        `${DMM_API_HOST}/v4.0.1/assistant/dmm/ranking`,
        {
          assistantId,
        },
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        getRankingList()
      })
  }

  const deleteRanking = async assistantId => {
    await axios
      .delete(`${DMM_API_HOST}/v4.0.1/assistant/dmm/ranking/${assistantId}`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(({ data }) => {
        getRankingList()
      })
  }

  const dmmRankingSubmit = async () => {
    await axios
      .post(
        `${DMM_API_HOST}/v4/dmm/events/characters/rankings`,
        {},
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        console.log(data)
        alert('DMM 랭킹 전송 완료')
      })
  }

  const renderPaging = (pageNumber, pageMap) => {
    let list = []
    let j = 0
    let i = 0

    let test = pageNumber !== 1 ? pageNumber - 1 : 1
    let last =
      pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount

    list.push(
      <Pagination.Item
        key="first"
        onClick={() => {
          setPageNumber(test)
        }}
      >
        &laquo;
      </Pagination.Item>
    )

    for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
      let num = pageMap.startPage * 1 + j

      if (num === pageMap.pageNumber * 1) {
        list.push(
          <Pagination.Item key={i} className="active">
            {num}
          </Pagination.Item>
        )
      } else {
        list.push(
          <Pagination.Item
            key={i}
            onClick={() => {
              setPageNumber(num)
            }}
          >
            {num}
          </Pagination.Item>
        )
      }
      j++
    }

    list.push(
      <Pagination.Item
        key="last"
        onClick={() => {
          setPageNumber(last)
        }}
      >
        &raquo;
      </Pagination.Item>
    )
    return <Pagination>{list}</Pagination>
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPageNumber(1)
    getAssistantList(1, search)
  }

  const keyEvent = e => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
  }

  const reorderPromise = (id, order) => {
    const params = {
      assistantId: id,
      order,
    }

    return new Promise(async (resolve, reject) => {
      axios
        .put(`${DMM_API_HOST}/v4.0.1/assistant/dmm/ranking/order`, params, {
          headers: {
            apikey: DMM_API_KEY,
          },
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  const reorder = async list => {
    const result = await Promise.all(
      list.map((item, index) => reorderPromise(item.character_id, index + 1))
    )

    if (result) {
      getRankingList()
    }
  }

  // drag and drop reorder
  const dragDataInit = {
    target: null,
    index: -1,
    move_left: [],
    move_right: [],
    updateList: [],
  }

  const [dragData, setDragData] = useState(dragDataInit)

  const _dragStart = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    setDragData({
      ...dragData,
      target: e.currentTarget,
      index: Number(e.currentTarget.dataset.index),
      updateList: [...rankingList],
    })

    e.dataTransfer.setData('text/html', '')
    e.dataTransfer.effectAllowed = 'move'
  }

  const _dragEnter = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const _dragged = Number(dragData.target.dataset.index)
    const _target = Number(e.currentTarget.dataset.index)
    let move_left = [...dragData.move_left]
    let move_right = [...dragData.move_right]

    if (_dragged > _target) {
      if (move_left.includes(_target)) {
        move_left = move_left.slice(0, move_left.indexOf(_target))
      } else {
        move_left = Array(_dragged - _target)
          .fill()
          .map((v, i) => i + _target)
          .reverse()
      }
      move_right = []
    } else if (_dragged < _target) {
      if (move_right.includes(_target)) {
        move_right = move_right.slice(0, move_right.indexOf(_target))
      } else {
        move_right = Array(_target - _dragged)
          .fill()
          .map((v, i) => _target - i)
          .reverse()
      }
      move_left = []
    } else {
      move_left = []
      move_right = []
    }

    setDragData({
      ...dragData,
      // updateList: updateData,
      index: _target,
      move_left,
      move_right,
    })

    console.log(move_left, move_right)
  }

  const _dragLeave = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    if (e.currentTarget === dragData.target) {
      e.currentTarget.style.visibility = 'hidden'
    }
  }

  const _dragEnd = e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    let updateData = [...dragData.updateList]

    const changeOrder = (i, t) => {
      const target = updateData.splice(i, 1)[0]
      updateData.splice(t, 0, target)
    }

    const _dragged = Number(e.currentTarget.dataset.index)
    let _target = Number(dragData.index)

    if (dragData.move_left.length > 0) {
      _target = dragData.move_left[dragData.move_left.length - 1]
    } else if (dragData.move_right.length > 0) {
      _target = dragData.move_right[dragData.move_right.length - 1]
    } else {
      _target = _dragged
    }

    changeOrder(_dragged, _target)

    setDrag(false)
    setRankingList(updateData)
    reorder(updateData)
    setDragData({
      ...dragData,
      move_left: [],
      move_right: [],
      updateList: [],
    })

    e.currentTarget.style.visibility = 'visible'
    e.dataTransfer.dropEffect = 'move'
  }

  const _dragCapture = async e => {
    if (!drag) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    const posW = e.target.getBoundingClientRect().width
    const right = rankingRef.current.getBoundingClientRect().right
    const left = rankingRef.current.getBoundingClientRect().left

    setPosX(posW) // posY를 posX처럼 사용해도 됨

    if (e.clientX && e.clientX > left && e.clientX < right) {
      if (right - e.clientX < 100) {
        setIsScroll('right')
      } else if (e.clientX - left < 100) {
        setIsScroll('left')
      } else {
        setIsScroll('')
      }
    }
  }

  useEffect(() => {
    const scrollLeft = rankingRef.current.scrollLeft
    const posW = rankingRef.current.getBoundingClientRect().width

    if (isScroll === 'right') {
      rankingRef.current.scrollTo({
        left: scrollLeft + posW - posX * 2,
        behavior: 'smooth',
      })
    }

    if (isScroll === 'left') {
      rankingRef.current.scrollTo({
        left: scrollLeft - posW + posX * 2,
        behavior: 'smooth',
      })
    }
  }, [isScroll])

  const dataComponent = () => {
    return (
      <Table>
        <tbody>
          <tr>
            {fieldList.map((field, index) => {
              return (
                (field !== 'assistantInfo' && field !== 'tags' ) && <Field key={index}>{field}</Field>
              )
            })}
          </tr>
          {assistantList.length > 0 &&
            assistantList.map((assistant, index) => {
              const added = !!rankingList.find(
                r => r.character_id === assistant.assistantId
              )
              let list = []

              for (const field of fieldList) {
                if (field === 'profileImg') {
                  list.push(
                    <td key={field + index}>
                      <img
                        src={assistant[field]}
                        alt=""
                        style={{ width: 100, height: 100 }}
                      />
                    </td>
                  )
                } else if (field === 'assistantImg') {
                  list.push(
                    <td key={field + index}>
                      <img
                        src={assistant[field]}
                        alt=""
                        style={{ width: 100, height: 100 }}
                      />
                    </td>
                  )
                } else if (field === 'instructions') {
                  list.push(
                    <td
                      key={field + index}
                      style={{
                        maxWidth: 200,
                        overflow: 'hidden',
                      }}
                    >
                      {assistant[field]}
                    </td>
                  )
                } else if (field === 'nudity') {
                  list.push(
                    <td key={field + index}>
                      {assistant[field] ? assistant[field][0].type : ''}
                    </td>
                  )
                } else if (field !== 'assistantInfo' && field !== 'tags') {
                  list.push(<td key={field + index}>{assistant[field]}</td>)
                }
              }

              return (
                <ListItem key={index} added={added}>
                  {list}
                  <div id="tr-hover">
                    <div id="button-wrapper">
                      {added ? (
                        <div
                          id="button"
                          onClick={() => deleteRanking(assistant.assistantId)}
                        >
                          -
                        </div>
                      ) : (
                        <div
                          id="button"
                          onClick={() => insertRanking(assistant.assistantId)}
                        >
                          +
                        </div>
                      )}
                    </div>
                  </div>
                </ListItem>
              )
            })}
        </tbody>
      </Table>
    )
  }

  return (
    <>
      <PageTitle
        mainTitle={'DMM Ranking'}
        v1Link={''}
        navNames={['DMM', 'Ranking']}
      />
      <SpaceResponsive height={10} />
      <Title style={{ display: 'flex', alignItems: 'center' }}>
        Auto Ranking
        <ButtonWrapper style={{ width: 'auto' }}>
          <button
            style={{ backgroundColor: '#dc143c' }}
            onClick={() => {
              setGender('all')
            }}
          >
            All
          </button>
          <button
            style={{ backgroundColor: '#007ffb' }}
            onClick={() => {
              setGender('male')
            }}
          >
            Male
          </button>
          <button
            style={{ backgroundColor: '#ff4500' }}
            onClick={() => {
              setGender('female')
            }}
          >
            Female
          </button>
        </ButtonWrapper>
      </Title>
      <RankingWrapper ref={rankingRef}>
        {autoRankingList &&
          autoRankingList.length > 0 &&
          autoRankingList.map((r, i) => {
            return (
              <RankingItem
                key={i}
                data={r}
                data-index={i}
                draggable={false}
                onClick={async e => {
                  await setPageNumber(1)
                  await setSearch(r.character_id)
                  await getAssistantList(1, r.character_id)
                }}
                onMouseDown={() => setDrag(true)}
              >
                <div id="hover">
                  <div>{r.character_id}</div>
                  <div>{r.character_name}</div>
                  <div>{r.gender}</div>
                </div>
                <img src={r.image_url} alt="" />
              </RankingItem>
            )
          })}
      </RankingWrapper>
      <Title style={{ display: 'flex', alignItems: 'center' }}>
        DMM Ranking
      </Title>
      <RankingWrapper ref={rankingRef}>
        {dmmRankingList &&
          dmmRankingList.length > 0 &&
          dmmRankingList.map((r, i) => {
            return (
              <RankingItem
                key={i}
                onClick={async e => {
                  await setPageNumber(1)
                  await setSearch(r.character_id)
                  await getAssistantList(1, r.character_id)
                }}
              >
                <div id="hover">
                  <div>{r.character_id}</div>
                  <div>{r.character_name}</div>
                  <div>{r.gender}</div>
                </div>
                <img src={r.image_url} alt="" />
              </RankingItem>
            )
          })}
      </RankingWrapper>
      <Title>Ranking</Title>
      <RankingWrapper ref={rankingRef}>
        {rankingList &&
          rankingList.length > 0 &&
          rankingList.map((r, i) => {
            let default_class = ''
            dragData.move_left.includes(i) && (default_class = 'move_left')
            dragData.move_right.includes(i) && (default_class = 'move_right')

            return (
              <RankingItem
                key={i}
                data={r}
                data-index={i}
                draggable={drag}
                onDragStart={_dragStart}
                onDragEnter={_dragEnter}
                onDragLeave={_dragLeave}
                onDragEnd={_dragEnd}
                onDragCapture={_dragCapture}
                className={default_class}
                onClick={async e => {
                  await setPageNumber(1)
                  await setSearch(r.character_id)
                  await getAssistantList(1, r.character_id)
                }}
                onMouseDown={() => setDrag(true)}
              >
                <div id="hover">
                  <div>{r.character_id}</div>
                  <div>{r.character_name}</div>
                  <div>{r.gender}</div>
                </div>
                <img src={r.image_url} alt="" />
              </RankingItem>
            )
          })}
      </RankingWrapper>
      <ButtonWrapper>
        <button
          style={{ backgroundColor: '#007ffb' }}
          onClick={() => {
            dmmRankingSubmit()
          }}
        >
          DMM 랭킹 전송
        </button>
      </ButtonWrapper>
      <SpaceResponsive height={10} />
      <AssistantWrapper>
        {/* <Title>Assistant</Title> */}
        <InputGroup onSubmit={handleSubmit}>
          <FormControl
            type="text"
            value={search}
            placeholder="Search"
            onChange={e => setSearch(e.target.value)}
            onKeyPress={keyEvent}
          />
          <Button
            variant="primary"
            onClick={handleSubmit}
            style={{ height: '38px' }}
          >
            <i className="fa fa-search" />
          </Button>
        </InputGroup>
        <Body headerWidth={'20%'} DataComponet={dataComponent} />
        {renderPaging(pageNumber, pageMap)}
      </AssistantWrapper>
    </>
  )
}

export default Ranking

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const Title = styled.div`
  font-size: 18px;
`

const RankingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 0 16px;
  overflow-x: scroll;
`

const RankingItem = styled.div`
  width: 180px;
  height: 180px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: center;
  position: relative;
  cursor: pointer;

  #hover {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    opacity: 0;
    transition: all 0.3s;
    pointer-events: none;
  }

  img {
    width: 180px;
    height: 180px;
    border-radius: 8px;
  }

  &:hover #hover {
    opacity: 1;
  }

  &.move_left {
    transform: translateX(180px);
    z-index: 1;
  }

  &.move_right {
    transform: translateX(-180px);
    z-index: 1;
  }
`

const AssistantWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`

const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border-collapse: collapse;
  border-spacing: 0;
`

const Field = styled.th`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  text-align: left;
`

const ListItem = styled.tr`
  background-color: ${props => (props.added ? '#f0f0f0' : '#fff')};
  position: relative;

  #tr-hover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    display: flex;
    justify-content: start;
    align-items: center;
  }

  #tr-hover > #button-wrapper {
    position: sticky;
    top: 50%;
    left: 0;
    width: calc(100dvw - 230px);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 2px;

    #button {
      width: 32px;
      height: 32px;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${props => (props.added ? '#dc143c' : '#007ffb')};
      padding-bottom: 4px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }

  &:hover #tr-hover {
    opacity: 1;
    pointer-events: auto;
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10px;
    color: #fff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
      font-weight: bold;
    }
  }
`
